import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TOption } from 'core/models/option.model';

interface ISellerPanelState {
  selectedStore: TOption | null;
}

const initialState: ISellerPanelState = {
  selectedStore: null,
};

const sellerPanelSlice = createSlice({
  name: 'sellerPanel',
  initialState,
  reducers: {
    setSelectedStore(state, action: PayloadAction<TOption>) {
      state.selectedStore = action.payload;
    },
  },
});

export const { setSelectedStore } = sellerPanelSlice.actions;
export default sellerPanelSlice.reducer;
